import { render } from "./CreateSSHKeyPair.vue?vue&type=template&id=3afa5c52&scoped=true"
import script from "./CreateSSHKeyPair.vue?vue&type=script&lang=js"
export * from "./CreateSSHKeyPair.vue?vue&type=script&lang=js"

import "./CreateSSHKeyPair.vue?vue&type=style&index=0&id=3afa5c52&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afa5c52"]])

export default __exports__